import { createComponent } from '@lib/util/templateHelpers';

export default createComponent('Block', {}, function Block ({ className, style }, props) {
  return (
    <div className={className} style={style}>
      {props.children}
    </div>
  );
});
